import { useEffect } from 'react'
import * as Sentry from '@sentry/tanstackstart-react'
import { createFileRoute, type ErrorComponentProps } from '@tanstack/react-router'
import AuthGuard from '../components/AuthGuard'
import { DeviceDetailClient } from '../components/DeviceDetailClient'

function DeviceDetailError({ error }: ErrorComponentProps) {
  useEffect(() => { Sentry.captureException(error) }, [error])
  return (
    <div className="p-8 text-center text-gray-600">
      Failed to load device.{' '}
      <button onClick={() => window.location.reload()} className="text-brand underline">
        Retry
      </button>
    </div>
  )
}

export const Route = createFileRoute('/devices/$id')({
  head: () => ({
    meta: [{ title: 'Device Detail | Unbreakable' }],
  }),
  errorComponent: DeviceDetailError,
  component: DeviceDetailPage,
})

function DeviceDetailPage() {
  const { id } = Route.useParams()
  return (
    <AuthGuard>
      <DeviceDetailClient deviceId={id} initialDevice={null} initialPolicies={null} initialAvailablePolicies={[]} />
    </AuthGuard>
  )
}
